import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/youth-vintage-vector-graphic-concept_53876-21297.jpg';

function ChildYouthDevelopment() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Child and Youth Development Programs" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Child and Youth Development Programs</h4>
              <p>
                This sub-department is focused on providing children and young people with access to programs and services that foster their growth and development.<br />
                Initiatives include early childhood education, mentorship programs, and after-school activities aimed at nurturing talent and building life skills.<br /><br />
                Our goal is to ensure every child has the opportunity to thrive and contribute positively to their community.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Early Childhood Education</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>After-School Enrichment Programs</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Mentorship and Leadership Initiatives</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are committed to empowering children and youth with the tools and support needed to achieve their full potential, fostering future leaders and active citizens.
              </p>
            </div>
            <div>
              <Link to="/department/family-services">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default ChildYouthDevelopment;
